<template>
  <div class="data-detail">
    <!-- <div class="title-wrap">
      <span class="prev-page" @click="$router.push({ name: 'IncomeData' })"
        >$vi18n('$i8n# 收益概览 #i18n$')</span
      >
      <img
        class="icon-arrows"
        src="../../assets/images/icon_page_connector.png"
      />
      <span class="current-page">$vi18n('$i1n# 收益详情 #i18n$')</span>
    </div> -->
    <div class="table-content">
      <DetailBill></DetailBill>
      <!-- <DetailWork></DetailWork> -->
    </div>
  </div>
</template>

<script>
import DetailBill from './components/incomeData/detailBill';
// import DetailWork from './components/incomeData/detailWork';

export default {
  name: 'DataDetail',
  components: {
    DetailBill,
    // DetailWork
  },
};
</script>

<style lang="scss" scoped>
.data-detail {
  font-size: 14px;
  margin-top: 30px;
  .title-wrap {
    font-size: 24px;
    color: #595959;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    margin-bottom: 24px;
    .icon-arrows {
      margin: 0 24px;
      color: #8c8c8c;
    }
    .prev-page {
      cursor: pointer;
    }
    .current-page {
      color: #8c8c8c;
    }
  }
}
</style>
